import React from 'react';
import classNames from 'classnames';

import './styles.css';

const ThreeStateCheckBox = ({
  onSelectAll,
  onDeselectAll,
  selected,
  deselected,
  className
}: any) => (
  <div
    onClick={
      (selected && onDeselectAll) ||
      (deselected && onSelectAll) ||
      onDeselectAll
    }
    className={classNames('ThreeStateCheckBox', className)}>
    {selected && !deselected && <div className="selected" />}
    {selected && deselected && <div className="middleState" />}
    {!selected && deselected && <div className="deselected" />}
    {!selected && !deselected && <div className="deselected" />}
  </div>
);

export default ThreeStateCheckBox;
